import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/storeDashboard/dashboard.css";
import { getLocalAdminSelectedStore, getLocalGarmentPack, getStoreLocalData, getUserData, removeLocalAdminSelectedStore, setLocalAdminSelectedStore, setLocalGarmentPack } from "../utils/localStorage";
import { getStoreOrderDashboardAdminNew } from "../services/DashboardAPI/DashboardApi";
import { useNavigate } from "react-router-dom";
import TabMenu from "./TabMenu";
import { getBrandStore } from "../services/StoreUsers/PostStoreUsers";
import AdminMenu from "./AdminMenu";
import SelectStoreInAdmin from "./SelectStoreInAdmin";
import { SubscriptionExpiryAlert } from "./ExpiredSoon";


import {
    Bar,
    Line,
    Pie,
    Doughnut,
    Radar,
    PolarArea,
    Scatter,
    Bubble,
} from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    RadarController,
    Tooltip,
    Title,
    Legend,
    RadialLinearScale,
} from "chart.js";
import { getGarmentPack } from "../services/GarmentCategory/GarmentCategory";
import { localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";
import SupportAdminMenu from "./SupportAdminMenu";
import FinanceAdminMenu from "./FinanceAdminMenu";
import FinanceTabMenu from "./FinanceTabMenu";

// Register components
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    RadarController,
    Tooltip,
    Title,
    Legend,
    RadialLinearScale
);

const { innerWidth: width, innerHeight: height } = window;

const backgroundImages = [
    "/Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Pickup.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Today_bookings.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Reprocess.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Rider_delivery.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Pending_orders.png",
    "/Laundy_App_Icons_Gifs/Home_Page/Rider_pickup.png",
    "/Laundy_App_Icons_Gifs/Home_Page/darkGreen.png",
    "/Laundy_App_Icons_Gifs/Home_Page/blue.png",
    "/Laundy_App_Icons_Gifs/Home_Page/brown.png",
    "/Laundy_App_Icons_Gifs/Home_Page/grey.png",
    "/Laundy_App_Icons_Gifs/Home_Page/orange.png",
    "/Laundy_App_Icons_Gifs/Home_Page/pink.png",
    "/Laundy_App_Icons_Gifs/Home_Page/wine.png",
    "/Laundy_App_Icons_Gifs/Home_Page/seaGreen.png",
];

const FinanceAdminDashboardNew = () => {
    const navigate = useNavigate();

    const { userProfileData, brandProfileData, userProfileRole } = getUserData();
    const { storeLocalData } = getStoreLocalData();
    let brandId = brandProfileData.id;
    let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;
    const userRole = userProfileRole;
    const subscriptionExpiryDate = userProfileData.nextRenewalOn;

    const base64String = `data:image/png;base64,${brandProfileData.logo}`;

    const [searchStoreModalMenuVisible, setSearchStoreModalMenuVisible] =
        useState(false);

    const [dashboardData, setDashboardData] = useState([]);
    const [visible, setVisible] = useState(false);

    let initialStartDate = new Date();
    initialStartDate.setDate(initialStartDate.getDate() - 7); // subtract 7 days to current date

    const [storeNameData, setStoreNameData] = useState("");
    const [storeIdData, setStoreIdData] = useState("");

    const chartsGradientOrder = {
        BOOKED: "#3EB3E1",
        INPROCESS: "#866CCE",
        PROCESSED: "#F5C43A",
        DELIVERED: "#09B4AA",
        DONE: "#55BD5A",
        CANCEL: "#FF6767",
        UNPROCESSED: "#5D53D8",
        OUT_FOR_DELIVERY: "#6EA4F5",
        DELAY_STATUS: "E89534",
        IN_WAREHOUSE: "#a906c2",
        DEFAULT: "#000",
    };

    const [orderDataNew, setOrderDataNew] = useState({});
    const [orderDataNew2, setOrderDataNew2] = useState({});

    const fetchStoreOrderDashboard = (data) => {
        getStoreOrderDashboardAdminNew(brandId, data)
            .then((response) => {
                const Res = response.data.data;
                const newRes = Res?.map((item, index) => ({
                    ...item,
                    backgroundImages: backgroundImages[index],
                    gradientCenterColor: chartsGradientOrder[item.status], // Assuming getRandomColor() generates a random color
                }));

                const resultOrderDataNew = {
                    labels: newRes?.map(
                        (item) => item.count + " - " + item.status.replace(/BY_/g, " ")
                    ),
                    datasets: [
                        {
                            label: "Total Order",
                            data: newRes?.map((item) => item.count),
                            backgroundColor: newRes?.map((item) => item.gradientCenterColor),
                        },
                    ],
                };

                const resultOrderDataNew2 = {
                    labels: newRes?.map(
                        (item) =>
                            item.itemGarmentCount + " - " + item.status.replace(/BY_/g, " ")
                    ),
                    datasets: [
                        {
                            label: "Total Piece",
                            data: newRes?.map((item) => item.itemGarmentCount),
                            backgroundColor: newRes?.map((item) => item.gradientCenterColor),
                            borderRadius: 2, // rounded corners
                            barThickness: 20, // bar width
                            borderSkipped: false, // rounded on both sides
                        },
                    ],
                };
                setOrderDataNew(resultOrderDataNew);
                setOrderDataNew2(resultOrderDataNew2);
                setDashboardData(newRes);
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: { position: "bottom" },
            title: {
                display: true,
                text: "Orders",
                font: {
                    size: 18,
                },
            },
        },
    };

    const chartOptions2 = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
                labels: {
                    font: {
                        size: 0,
                        weight: "bold",
                    },
                },
            },
            title: {
                display: true,
                text: "Piece",
                font: {
                    size: 18,
                },
            },

            tooltip: {
                backgroundColor: "#333",
                titleFont: { size: 14 },
                bodyFont: { size: 13 },
                padding: 10,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        size: 13,
                    },
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: "rgba(200,200,200,0.2)",
                },
                ticks: {
                    stepSize: 5,
                    font: {
                        size: 13,
                    },
                },
            },
        },
    };

    // ✅ Fetch All or Specific Store(s)
    const fetchBrandStoreInfo = async (storeId) => {
        try {
            const response = await getBrandStore(brandId);
            if (!response.data.error) {
                const stores = response.data || [];
                const storeIds = storeId ? [storeId] : stores.map((item) => item.id);

                const data = {
                    storeIds,
                    statusIn: [],
                    startDate: localeDateStartDate(new Date(new Date())),
                    endDate: localeDateEndDate(new Date(new Date())),
                    pendingStartDate: initialStartDate,
                    localeDTO: storeLocalData
                };

                fetchStoreOrderDashboard(data);
            }
        } catch (err) {
            console.error("Error fetching store info:", err);
        }
    };

    const receiveDataFromSearchStoreModal = ({ storeInfo }) => {
        if (!storeInfo) return;

        setLocalAdminSelectedStore(storeInfo);
        setStoreNameData(storeInfo.storeName);
        setStoreIdData(storeInfo.id);
        fetchBrandStoreInfo(storeInfo.id);
    };


    // ✅ Fetch store from localStorage if available
    const fetchLocalAdminSelectedStore = () => {
        const { adminSelectedStore } = getLocalAdminSelectedStore();
        if (adminSelectedStore && Object.keys(adminSelectedStore).length > 0) {
            setStoreNameData(adminSelectedStore.storeName);
            setStoreIdData(adminSelectedStore.id);
            fetchBrandStoreInfo(adminSelectedStore.id);
            return true;
        }
        return false;
    };

    const [storeGarmentPack, setStoreGarmentPack] = useState([])

    const fetchStoreGarmentPack = async () => {
        try {
            const response = await getGarmentPack(brandId);
            if (!response.data.error) {
                const Res = response.data;
                setStoreGarmentPack(Res);
                setLocalGarmentPack(Res);
            }
        } catch (err) {
            console.error("Error:", err);
        }
    };

    const fetchLocalGarmentPack = async () => {
        const { garmentPack } = getLocalGarmentPack();
        if (garmentPack && Object.keys(garmentPack).length > 0) {
            setStoreGarmentPack(garmentPack);
        } else {
            await fetchStoreGarmentPack();
        }
    };

    // ✅ Auto-run logic on mount
    useEffect(() => {
        const hasLocalStore = fetchLocalAdminSelectedStore();
        if (!hasLocalStore) {
            // If no store selected → fetch all
            fetchBrandStoreInfo();
            fetchLocalGarmentPack()
        }
    }, []);

    const refreshDashboard = ({ success }) => {
        if (success) {
            fetchBrandStoreInfo();
            removeLocalAdminSelectedStore(); // or localStorage.removeItem("adminSelectedStore")
            setStoreNameData(null);
            setStoreIdData(null);
        }
    };

    const renderNewDashboardCard1 = () => {
        const totalOrder = dashboardData
            ?.filter((item) => item.status !== "CANCEL")
            .reduce((acc, item) => acc + item.count, 0);

        return (
            <div
                className="relative overflow-hidden mx-4 my-3"
                // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
                style={{ cursor: "pointer" }}
            >
                <img
                    className=" h-9rem w-10rem"
                    src={backgroundImages[2]}
                    alt={"total orders"}
                />
                <div
                    className="absolute pl-3 border-round-xs"
                    style={{
                        top: "20%",
                    }}
                >
                    <p className="text-white text-3xl font-bold uppercase">
                        {totalOrder}
                    </p>
                    <p className="text-white text-base font-bold uppercase">
                        {"Total Order"}
                    </p>
                </div>
            </div>
        );
    };

    const renderNewDashboardCard2 = () => {
        const totalOrder = dashboardData
            ?.filter((item) => item.status === "CANCEL")
            .reduce((acc, item) => acc + item.count, 0);

        return (
            <div
                className="relative overflow-hidden mx-4 my-3"
                // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
                style={{ cursor: "pointer" }}
            >
                <img
                    className=" h-9rem w-10rem"
                    src={backgroundImages[3]}
                    alt={"Cancel Order"}
                />
                <div
                    className="absolute py-2 pl-3 border-round-xs"
                    style={{
                        top: "20%",
                    }}
                >
                    <p className="text-white text-3xl font-bold uppercase">
                        {totalOrder}
                    </p>
                    <p className="text-white text-base font-bold uppercase">
                        {"Cancel Order"}
                    </p>
                </div>
            </div>
        );
    };

    const renderNewDashboardCard3 = () => {
        const totalRevenue = dashboardData
            ?.filter((item) => item.status !== "CANCEL")
            .reduce((acc, item) => acc + item.total, 0);

        return (
            <div
                className="relative overflow-hidden mx-4 my-3"
                // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
                style={{ cursor: "pointer" }}
            >
                <img
                    className=" h-9rem w-10rem"
                    src={backgroundImages[0]}
                    alt={"Total Revenue"}
                />
                <div
                    className="absolute py-2 pl-3 border-round-xs"
                    style={{
                        top: "20%",
                    }}
                >
                    <p className="text-white text-3xl font-bold uppercase">
                        {storeLocalData?.currencySymbol} {Number(totalRevenue)?.toFixed(enabledAmountRoundOffAdmin)}
                    </p>
                    <p className="text-white text-base font-bold uppercase">
                        {"Total Revenue"}
                    </p>
                </div>
            </div>
        );
    };

    const renderNewDashboardCard4 = () => {
        const totalGarments = dashboardData
            ?.filter((item) => item.status !== "CANCEL")
            .reduce((acc, item) => acc + item.itemGarmentCount, 0);

        return (
            <div
                className="relative overflow-hidden mx-4 my-3"
                // onClick={() => onSelectCardItem(id, storeOrderByStatus)}
                style={{ cursor: "pointer" }}
            >
                <img
                    className=" h-9rem w-10rem"
                    src={backgroundImages[1]}
                    alt={"Processed"}
                />
                <div
                    className="absolute py-2 pl-3 border-round-xs"
                    style={{
                        top: "20%",
                    }}
                >
                    <p className="text-white text-3xl font-bold uppercase">
                        {totalGarments}
                    </p>
                    <p className="text-white text-base font-bold uppercase">
                        {"Total Piece"}
                    </p>
                </div>
            </div>
        );
    };

    return (
        <div className="flex-1">
            <div
                className="h-8rem border-round-bottom surface-0 sticky z-1 top-0"
                style={{
                    "--border-radius": "50px",
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex flex-row ml-3 mr-3 pt-2">
                    <div className="flex-1 flex flex-row">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div
                                className="h-4rem w-4rem border-circle bg-white flex justify-content-center align-items-center cursor-pointer"
                                onClick={() => navigate("/UserProfile")}
                            >
                                {brandProfileData.logo ? (
                                    <img
                                        style={{ width: "35px" }}
                                        src={base64String}
                                        alt="logo"
                                    />
                                ) : (
                                    <img
                                        style={{ width: "35px" }}
                                        src="/warehouse/entrepreneur.png"
                                        alt="logo"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="flex-1 ml-3">
                            <p className="text-white text-xl font-bold uppercase">
                                {userProfileData.firstName.replace(/_/g, " ")}{" "}
                                {userProfileData.lastName.replace(/_/g, " ")}
                            </p>
                            <p className="text-white text-base font-bold uppercase">
                                {userRole === "BY_ADMIN" ? "ADMIN" : "SUB ADMIN"} -{" "}
                                {brandProfileData.name.replace(/_/g, " ")}
                            </p>
                            <p className="text-white text-sm font-light">
                                <img
                                    style={{ width: "10px", marginRight: 5 }}
                                    src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Location.png"
                                    alt="logo"
                                />
                                {brandProfileData.address.addressLine1 +
                                    " " +
                                    brandProfileData.address.addressLine2 +
                                    " " +
                                    brandProfileData.address.city +
                                    " " +
                                    brandProfileData.address.state}
                            </p>
                        </div>
                    </div>
                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
                        ></i>
                    </div>
                </div>
                <div className="flex-1 flex flex-row">
                    <div
                        className="flex-1 flex justify-content-start align-items-center relative mt-3 mx-5 h-3rem bg-white border-round-xl shadow-4"
                    // onClick={() => setSearchStoreModalMenuVisible(true)}
                    // style={{ cursor: "pointer" }}
                    >
                        <img
                            style={{ width: "20px", marginLeft: 10, marginRight: 10 }}
                            src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Search.png"
                            alt="logo"
                        />
                        <p
                            style={{
                                color: "#75879B",
                                fontSize: 16,
                            }}
                        >
                            All Store
                        </p>
                    </div>
                </div>
            </div>
            <div className="flex flex-1" style={{ marginBottom: 100 }}>
                <div style={{ flex: 1 }}>
                    <div
                        className="px-0 ml-2 mr-2 relative  mt-5 flex justify-content-center align-items-center"
                        style={{ flex: 1 }}
                    >
                        {renderNewDashboardCard1()}
                        {renderNewDashboardCard3()}
                    </div>
                    <div
                        className="px-0 ml-2 mr-2 relative  mt-1 flex justify-content-center align-items-center"
                        style={{ flex: 1 }}
                    >
                        {renderNewDashboardCard2()}
                        {renderNewDashboardCard4()}
                    </div>

                    <div
                        className="flex justify-content-center align-items-center"
                        style={{ paddingTop: 10 }}
                    >
                        <button
                            className="golden-button-new-dashboard "
                            onClick={() => navigate("/full-dashboard")}
                        >
                            <span className="shine" />
                            Full Dashboard{" "}
                            <i
                                className="pi pi-send"
                                style={{
                                    position: "relative",
                                    top: 4,
                                    marginLeft: 3,
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "#fff",
                                }}
                            ></i>
                        </button>
                    </div>
                </div>
                {dashboardData?.length > 0 ? (
                    <div className="flex" style={{ flex: 1 }}>
                        <div className="px-0 ml-5 mr-1 relative mt-5" style={{ flex: 0.5 }}>
                            <div
                                className="flex  bg-white border-round-xl shadow-4"
                                style={{ height: height < 600 ? 280 : 350 }}
                            >
                                <Bar
                                    data={orderDataNew2}
                                    options={chartOptions2}
                                    height={300}
                                    width={450}
                                />
                            </div>
                        </div>
                        <div className="px-0 ml-5 mr-5 relative mt-5" style={{ flex: 0.5 }}>
                            <div
                                className="flex  bg-white border-round-xl shadow-4"
                                style={{ height: height < 600 ? 280 : 350 }}
                            >
                                <Doughnut data={orderDataNew} options={chartOptions} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className="mt-6 mr-4 flex justify-content-center align-items-center bg-white border-round-xl shadow-4"
                        style={{ flex: 1 }}
                    >
                        <p className="text-3xl font-bold">No Booking Found</p>
                    </div>
                )}
            </div>
            <SelectStoreInAdmin
                setSearchStoreModalMenuVisible={setSearchStoreModalMenuVisible}
                searchStoreModalMenuVisible={searchStoreModalMenuVisible}
                sendDataToAdminDashboard={receiveDataFromSearchStoreModal}
                refreshDashboard={refreshDashboard}
                brandId={brandId}
            />
            <FinanceTabMenu />
            <div>
                <SubscriptionExpiryAlert expiryDate={subscriptionExpiryDate} />

                <FinanceAdminMenu setVisible={setVisible} visible={visible} />
            </div>
        </div>
    );
};

export default FinanceAdminDashboardNew;


